"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfficeThemeElementsDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var destination_1 = require("../destination");
var office_theme_color_scheme_destination_1 = require("./color/office-theme-color-scheme-destination");
var office_theme_font_scheme_destination_1 = require("./font/office-theme-font-scheme-destination");
var office_theme_format_scheme_destination_1 = require("./format/office-theme-format-scheme-destination");
var OfficeThemeElementsDestination = (function (_super) {
    tslib_1.__extends(OfficeThemeElementsDestination, _super);
    function OfficeThemeElementsDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(OfficeThemeElementsDestination.prototype, "elementHandlerTable", {
        get: function () {
            return OfficeThemeElementsDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    OfficeThemeElementsDestination.handlerTable = new map_creator_1.MapCreator()
        .add('clrScheme', function (data) { return new office_theme_color_scheme_destination_1.OfficeThemeColorSchemeDestination(data); })
        .add('fontScheme', function (data) { return new office_theme_font_scheme_destination_1.OfficeThemeFontSchemeDestination(data); })
        .add('fmtScheme', function (data) { return new office_theme_format_scheme_destination_1.OfficeThemeFormatSchemeDestination(data); })
        .get();
    return OfficeThemeElementsDestination;
}(destination_1.ElementDestination));
exports.OfficeThemeElementsDestination = OfficeThemeElementsDestination;
